@layer components {
  .dialog {
    container-type: inline-size;
    inline-size: min(28rem, 100% - 2 * max(var(--space-4), env(safe-area-inset-left)));
    max-inline-size: none;
    max-block-size: calc(100dvh - 2 * var(--space-4));
    margin: auto;
    padding: 0;
    border: 0;
    border-radius: var(--radius-sheet);
    background: var(--color-surface);
    color: var(--color-text);
    box-shadow: var(--shadow-lg);

    &::backdrop {
      background: color-mix(
        in oklch,
        color-mix(in oklch, var(--color-frame), black 35%),
        transparent 38%
      );
    }

    &[open] {
      animation:
        dialog-in var(--duration-spring) var(--ease-spring),
        fade var(--duration-fast) var(--ease-out);

      &::backdrop {
        animation: fade var(--duration-base) var(--ease-out);
      }
    }
  }

  @keyframes dialog-in {
    from {
      scale: 0.88;
      translate: 0 0.75rem;
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
  }

  .body {
    --pad: clamp(var(--space-5), 4cqi, var(--space-8));

    display: grid;
    justify-items: start;
    gap: var(--space-3);
    padding: var(--pad);
  }

  .blob {
    display: grid;
    place-items: center;
    inline-size: 3.25rem;
    block-size: 3.25rem;
    margin-block-end: var(--space-1);
    border-radius: var(--radius-lg);
    background: var(--color-danger-soft);
    color: var(--color-danger);
    rotate: -6deg;

    & svg {
      inline-size: 1.625rem;
      block-size: 1.625rem;
      stroke-width: 2.2;
    }
  }

  .title {
    font-family: var(--font-display);
    font-size: var(--text-xl);
    font-weight: 700;
    line-height: 1.2;
    overflow-wrap: anywhere;
    text-wrap: balance;
  }

  .message {
    display: grid;
    justify-self: stretch;
    gap: var(--space-2);
    color: var(--color-text-muted);
    font-size: var(--text-base);
    line-height: 1.5;
    text-wrap: pretty;
  }

  .error {
    inline-size: 100%;
    padding: var(--space-2) var(--space-3);
    border-radius: var(--radius-md);
    background: var(--color-danger-soft);
    color: var(--color-danger);
    font-size: var(--text-sm);
    font-weight: 560;
  }

  /* Sticks to the dialog's scroll edge, so a long form keeps its buttons in reach. */
  .actions {
    position: sticky;
    inset-block-end: 0;
    display: flex;
    flex-wrap: wrap-reverse;
    justify-self: stretch;
    gap: var(--space-2);
    margin: 0 calc(-1 * var(--pad)) calc(-1 * var(--pad));
    padding: var(--space-3) var(--pad) var(--pad);
    background: linear-gradient(to top, var(--color-surface) 75%, transparent);

    & > * {
      flex: 1 1 auto;
    }

    @container (inline-size >= 26rem) {
      justify-content: flex-end;

      & > * {
        flex: none;
      }
    }
  }

  .form {
    text-align: start;
  }

  .field {
    display: grid;
    gap: var(--space-2);
    inline-size: 100%;
  }

  .fieldLabel {
    font-size: var(--text-sm);
    font-weight: 650;
  }

  .candyBlob {
    --candy: var(--sticker-folder);

    display: grid;
    flex: none;
    place-items: center;
    inline-size: 3.25rem;
    block-size: 3.25rem;
    margin-block-end: var(--space-1);
    border-radius: var(--radius-blob);
    background: var(--candy-gloss), var(--candy);
    color: var(--sticker-ink);
    box-shadow:
      inset 0 -4px 6px -2px color-mix(in oklch, var(--candy), black 22%),
      var(--shadow-candy-drop-sm);
    rotate: -6deg;

    & svg {
      inline-size: 1.5rem;
      block-size: 1.5rem;
      stroke-width: 2.2;
    }
  }
}
